module.exports = __webpack_public_path__ + "img/logomark-white.70546d47.svg";